import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.less']
})
export class ConfirmationDialogComponent implements OnInit {
  showSpinner: boolean;
  showError: boolean;
  errorMessage: '';
  title: string;
  label: string;
  confirmationText: string;
  rejectionText: string;
  hideFooter: boolean;
  showForgotPassword: boolean;
  emailSent: boolean;
  className: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: 
    {
      title: string,
      label: string, 
      confirmationText: string, 
      rejectionText: string, 
      hideFooter: boolean,
      className: string,
    }, public dialogRef: MatDialogRef<ConfirmationDialogComponent>) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.label = this.data.label;
    this.confirmationText = this.data.confirmationText;
    this.rejectionText = this.data.rejectionText;
    this.hideFooter = this.data.hideFooter;
    this.className = this.data.className;
  }

  onConfirmation() {
    this.dialogRef.close(true);
  }

  onRejection() {
    this.dialogRef.close(false);
  }

}
